<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
  <div class="flex w-[420px] flex-col gap-6 rounded-2xl bg-white p-6 shadow-xl">
    <div class="flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" class="text-danger-text">
          <path
            fill="currentColor"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
        </svg>
      </div>
      <h3 class="text-title text-[16px] font-[600]" i18n="@@confirmCancel.title">Confirm Cancel</h3>
    </div>

    <p class="text-neutral-text text-[14px]" i18n="@@confirmCancel.message">
      Are you sure you want to cancel this action?
    </p>

    <div class="flex justify-end gap-3">
      <button
        type="button"
        (click)="onDismiss()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-2 text-[13px] font-[500] text-white hover:cursor-pointer"
        i18n="@@confirmCancel.no">
        No, Keep Editing
      </button>
      <button
        type="button"
        (click)="onConfirm()"
        class="border-border text-text-gray rounded-[6px] border px-5 py-2 text-[13px] font-[500] hover:cursor-pointer hover:bg-gray-50"
        i18n="@@confirmCancel.yes">
        Yes, Cancel
      </button>
    </div>
  </div>
</div>
